<template>
  <v-app>
    <v-main>
      <Login @sign-in="onSignIn" v-bind:toRelogin="toRelogin"></Login>
    </v-main>
  </v-app>
</template>

<script>
import Login from "./components/common/Login";

export default {
  name: "VerifyPass",
  components: { Login },
  data: function () {
    return {
      toRelogin: {
        username: null,
        password: null
      }
    };
  },
  methods: {
    onSignIn: function () {
      this.$router.push("/").catch(() => {});
    }
  }
};
</script>
